import React, { useState, useEffect, useContext } from "react";
import { Button } from "antd";
import { getProductSpares } from "../services/apiService";
import { showSnackbar } from "../comopnents/snackbar.jsx";
import { AddItemToCart, AddItemToWishList, DeleteFromWishList, getProductQty } from "../services/Cart.jsx";
import { CartContext } from "../contextApi/CartContext.jsx";
import { FaHeart, FaRegHeart } from "react-icons/fa6";
import AuthModal from "../comopnents/AuthModal.jsx";
import { Notifyed } from "../services/Auth.jsx";
import noimage from "../assets/noimage.webp";
import LoadingSpinner from "./LoadingSpinner.jsx";
import CartQuantityControl from "./CartQuantityControl.jsx";
import {
  buildCartPurchaseData,
  buildEnhancedPurchaseData,
  getMinOrderQty,
  getMinimumPurchaseQuantity,
  getPurchaseQuantityStep,
  getSavedCartPurchaseData,
  shouldShowPurchaseModal,
} from "../utils/purchaseOptions.js";
import PurchaseOptionsModal from "./PurchaseOptionsModal.jsx";
import { isOutOfStock } from "../utils/stock.js";

const ProductSpares = ({ productId, navigate, onProductClick }) => {
  const [spares, setSpares] = useState([]);
  const [loading, setLoading] = useState(false);
  const [wishlistItems, setWishlistItems] = useState([]);
  const [wishlist, setWishlist] = useState({});
  const { addToCart, itemList, setCartQty } = useContext(CartContext);
  const [showAuthModal, setShowAuthModal] = useState(false);
    const [pendingCart, setPendingCart] = useState(null);
  const isLoggedIn = Boolean(localStorage.getItem("token"));

  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [pendingPurchaseProduct, setPendingPurchaseProduct] = useState(null);

  useEffect(() => {
      console.log("productId changed:", productId);
    if (productId) loadSpares(productId);
  }, [productId]);

  const loadSpares = async (id) => {
    try {
      setLoading(true);
      const res = await getProductSpares(id);
      setSpares(res || []);
    } catch (e) {
      console.error("Error loading product spares:", e);
    } finally {
      setLoading(false);
    }
  };

  const handleAuthSuccess = () => {
    setShowAuthModal(false);

  };
  const handleNotifyMe = async (productid) => {
    const userId = localStorage.getItem("userId");

    // If not logged in → open login modal
    if (!userId) {
      // setPendingCartId(productid);
      setShowAuthModal(true);
      return;
    }

    try {
      const response = await Notifyed({
        customerid: userId,
        productid: productid,
      });

      console.log("Notify me success:", response);
      showSnackbar("success", "We will notify you when product is available");
    } catch (error) {
      console.error("Notify me error:", error.response?.data || error.message);
      showSnackbar("error", "Failed to register notify request");
    }
  };
  const AddToWishList = async (productid) => {
    try {
      const userId = localStorage.getItem("userId");
      if (!userId) {
        setPendingCartId(productid);
        setShowAuthModal(true);
        return;
      }

      if (wishlistItems.includes(productid)) return;

      await AddItemToWishList({ productid, customerid: userId });
      setWishlistItems((prev) => [...prev, productid]);
      showSnackbar("success", "Added to wishlist!");
    } catch (error) {
      console.error("Wishlist error:", error.response?.data || error.message);
    }
  };
  const handleProductClick = (id) => {
    const url = `/productdetail?productid=${id}`;
    window.open(url, "_blank");

    setTimeout(() => {
      onProductClick?.();
    }, 0);
  };

  const handleDeleteWishList = async (productid) => {
    try {
      const userId = localStorage.getItem("userId");
      if (!userId) {
        setShowAuthModal(true);
        return;
      }

      await DeleteFromWishList({
        customerid: userId,
        productid: productid,
      });

      setWishlistItems((prev) => prev.filter((id) => id !== productid));
      showSnackbar("success", "Removed from wishlist");
    } catch (err) {
      console.error("Error deleting from wishlist:", err);
    }
  };

  const openPurchaseModal = (product) => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      setPendingPurchaseProduct(product);
      setShowAuthModal(true);
      return;
    }

    if (!shouldShowPurchaseModal(product)) {
      addItemToCart(product, getMinOrderQty(product));
      return;
    }
    setPendingPurchaseProduct(product);
    setShowPurchaseModal(true);
  };

  const confirmPurchaseType = async (purchaseType, couponData) => {
    if (!pendingPurchaseProduct) return;
    const purchaseData = buildEnhancedPurchaseData(pendingPurchaseProduct, purchaseType, couponData);
    await addItemToCart(pendingPurchaseProduct, purchaseData.quantity, purchaseData);
    setShowPurchaseModal(false);
    setPendingPurchaseProduct(null);
  };

  const addItemToCart = async (product, qty, purchaseData = null) => {
    try {
      const userId = localStorage.getItem("userId");
      const finalQty = qty || product.minorderqty || product.dtl?.[0]?.minorderqty || 1;
      if (isOutOfStock(product)) {
        await handleNotifyMe(product.productid);
        return;
      }

      if (!userId) {
        setShowAuthModal(true);
        return;
      }

      await AddItemToCart({
        customerid: userId,
        productid: product.productid,
        qty: finalQty,
        stock: product.stock || product.dtl?.[0]?.stock,
      });

      addToCart(product.productid, finalQty, purchaseData);

      showSnackbar(
        "success",
        `${product.displaymodelno} added to cart!`
      );
    } catch (error) {
      console.error("Add to cart error:", error);
      showSnackbar("error", "Failed to add to cart");
    }
  };

  const handleCartQtyChange = async (product, qty) => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      setShowAuthModal(true);
      return;
    }

    try {
      await getProductQty({ user_id: userId, productid: product.productid, qty });
      setCartQty(product.productid, qty);
    } catch (error) {
      console.error("API Error:", error?.message || error);
      showSnackbar("error", "Failed to update quantity");
    }
  };

  const addToWishlist = async (product) => {
    try {
      const userId = localStorage.getItem("userId");

      if (!userId) {
         setPendingCart({ product, purchaseType });
      setShowAuthModal(true);
        alert("Please login to add items to wishlist");
        return;
      }

      if (wishlistItems.includes(product.productid)) {
        showSnackbar("info", "Already in wishlist");
        return;
      }

      await AddItemToWishList({
        productid: product.productid,
        customerid: userId,
      });

      setWishlistItems((prev) => [...prev, product.productid]);

      showSnackbar("success", "Added to Wishlist!");
    } catch (error) {
      console.error("Wishlist error:", error);
      showSnackbar("error", "Failed to add to wishlist");
    }
  };

  return (
    <>
      {loading && (
        <LoadingSpinner text="Loading products..." />
      )}

      {!loading && spares.length > 0 && (
        <>
          <h2 style={{ marginTop: 20, color: "#005487" }}>
            Product Spares
          </h2>

          <div className="product-container">
            {spares.map((record) => {
              const mrp = Number(record.mrp);
              const discount = record.discount || 0;
              const price = Math.round(mrp * (1 - discount / 100));
              const qty =
                itemList.find(
                  (item) => String(item.productId) === String(record.productid),
                )?.count || 0;
              const minorderqty = record.minorderqty || record.dtl?.[0]?.minorderqty || 1;
              const stock = record.stock || record.dtl?.[0]?.stock || 0;
              const netrate = Number(record.netrate || record.dtl?.[0]?.netrate || 0);
              const savedPurchaseData = getSavedCartPurchaseData(record.productid);
              const purchaseType = savedPurchaseData?.purchaseType || "piece";

              return (
                <div key={record.productid} className="product-card">
                  <button
                    type="button"
                    className="product-image-btn"
                    onClick={() => handleProductClick(record.productid)}
                  >
                    <div
                      className="spares-actions"
                      style={{
                        position: "absolute",
                        top: "-12px",
                        left: "10px",
                        right: "10px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        zIndex: 2,
                      }}
                    >
                      {isLoggedIn && ((stock > 0 && netrate > 0) || discount > 0) && (
                        <span
                          className="discount-badge"
                          style={{
                            top: "13px",
                            left: "-8px",
                            background: "linear-gradient(135deg, #ff4d4d, #d90429)",
                            color: "#fff",
                            padding: "4px 2px",
                            borderRadius: "6px",
                            fontSize: "11px",
                            fontWeight: "700",
                            lineHeight: 1,
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {stock > 0 && netrate > 0 ? "Netrate" : `${discount}% OFF`}
                        </span>
                      )}

                      <button
                        className="wishlist-btn"
                        style={{
                          position: "absolute",
                          top: "6px",
                          right: "-6px",
                          width: "40px",
                          height: "40px",
                          border: "none",
                          borderRadius: "50%",
                          background: "#fff",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          zIndex: 10,
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setWishlist((prev) => {
                            const updated = !prev[record.productid];
                            updated
                              ? AddToWishList(record.productid)
                              : handleDeleteWishList(record.productid);
                            return { ...prev, [record.productid]: updated };
                          });
                        }}
                        aria-label={
                          wishlist[record.productid]
                            ? "Remove from wishlist"
                            : "Add to wishlist"
                        }
                        type="button"
                       >
                        {wishlist[record.productid] ? (
                          <FaHeart color="#ff4d4f" size={18} />
                        ) : (
                          <FaRegHeart size={18} />
                        )}
                      </button>
                    </div>
                    <img
                      src={
                        record.image1?.trim() ||
                        record.exploreimage?.trim() ||
                        noimage
                      }
                      alt={record.displaymodelno || "Product"}
                      onError={(e) => (e.target.src = noimage)}
                    />
                  </button>

                   <strong className="card-model-name">
                    {(
                      record.displaymodelno ||
                      record.mainmodelno ||
                      record.modelno
                    )?.toUpperCase()}
                   </strong>

                     <div className="partno-row" style={{ marginBottom: "-10px", fontSize: "12px", color: "#667085" }}>
                    <span>Part No:{record.partno}</span>
                 </div>

                 <div className="card-brand-row">
                    <span>{record.mainmodelno}</span>
                   
                  </div>
                  
                 <small className="card-category">
                    {record.category
                      ?.charAt(0)
                      .toUpperCase() +
                      record.category?.slice(1).toLowerCase()}
                  </small>


                  <div className="card-brand-row">
                    <span>{record.brand}</span>
                   
                  </div>
                 
                  <p className="product-price-row" style={{ display: "flex", flexDirection: "column-reverse", alignItems: "flex-start", gap: "3px", margin: "0" }}>
                    {Number(mrp) > 0 && (
                      <>
                        {(!isLoggedIn || netrate <= 0) && (
                          <span className="product-mrp">
                            MRP {Number(mrp).toFixed(2)}
                          </span>
                        )}
                        {isLoggedIn && (
                          <span
                            className="product-price"
                            style={{
                              color: "#005487",
                              fontSize: "15px",
                              fontWeight: "600",
                            }}
                          >
                            Rs. {Number(netrate > 0 ? netrate : price).toFixed(2)}
                          </span>
                        )}
                      </>
                    )}
                  </p>

                  <div className="card-action-area">
                    {stock <= 0 ? (
                      <button
                        className="spares-action-btn notify"
                        onClick={() => handleNotifyMe(record.productid)}
                      >
                        Notify Me
                      </button>
                    ) : qty > 0 ? (
                      <CartQuantityControl
                        qty={qty}
                        minQty={getMinimumPurchaseQuantity(record, purchaseType)}
                        step={purchaseType !== "piece" ? getPurchaseQuantityStep(record, purchaseType) : undefined}
                        stock={stock}
                        purchaseType={purchaseType}
                        product={record}
                        onChange={(newQty) => handleCartQtyChange(record, newQty)}
                        className="qty-box"
                      />
                    ) : (
                      <button
                        className="spares-action-btn add"
                        onClick={() => openPurchaseModal(record)}
                      >
                        Add to Cart
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}

      {showAuthModal && (
        <AuthModal
          initialMode="login"
          onClose={() => setShowAuthModal(false)}
          onSuccess={handleAuthSuccess}
        />
      )}

      <style>{`
.product-container {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  margin-top: 20px;
}

@media (max-width: 1200px) {
  .product-container {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

@media (max-width: 992px) {
  .product-container {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 480px) {
  .product-container {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.product-card {
  position: relative;
  width: 100%;
  background: #fff;
  border: 1px solid #cecdcd;
  border-radius: 8px;
  color: #4b5563;
  cursor: pointer;
  padding: 14px;
  text-align: left;
  transition:
    border-color 0.25s ease,
    box-shadow 0.25s ease,
    transform 0.25s ease;
  display: flex;
  flex-direction: column;
  height: auto;
  box-sizing: border-box;
}

.product-card:hover {
  transform: translateY(-6px);
}

.product-image-btn {
  border: none;
  background: transparent;
  padding: 0;
  width: 100%;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
  height: 175px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.product-image-btn img {
  background: #fff;
  border-radius: 8px;
  display: block;
  height: 120px !important;
  object-fit: contain;
  width: 78%;
}

.discount-badge {
  background: linear-gradient(135deg, #ff4d4d, #d90429);
  color: #fff;
  padding: 5px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  white-space: nowrap;
}

.wishlist-btn {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.wishlist-btn:hover {
  transform: scale(1.08);
}

.card-brand-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  flex-shrink: 0;
  min-height: 24px;
  margin-bottom: 0px;
  margin-top: 12px;
}

.card-brand-row > span {
  color: #667085;
  font-size: 12px;
  font-weight: 700;
  text-transform: capitalize;
}

.card-model-name {
  font-size: 12px;
  font-weight: 600;
  line-height: 1.35;
  margin-bottom: 6px;
  text-transform: uppercase;
  flex-shrink: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-category {
  color: #667085;
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 6px;
  text-transform: capitalize;
  flex-shrink: 0;
  min-height: 1.4em;
  display: contents;
}

.product-price-row {
  align-items: center;
  display: flex !important;
  gap: 10px;
  flex-shrink: 0;
  min-height: 28px;
  margin: 0;
  padding: 2px 0;
}

.product-mrp {
  color: #005487;
  display: inline;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 0;
  text-decoration: line-through;
}

.product-price {
  display: inline;
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 0;
}

.card-action-area {
  margin-top: auto;
  flex-shrink: 0;
  width: 100%;
}

.spares-action-btn {
  width: 100%;
  padding: 11px;
  border-radius: 25px;
  border: none;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.spares-action-btn.add {
  background-color: #005487;
  color: #ffffff;
}

.spares-action-btn.notify {
  background-color: #e0e0e0;
  color: #777777;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .product-card {
    padding: 10px;
  }

  .product-image-btn {
    height: 130px;
  }

  .product-image-btn img {
    height: 120px;
  }

  .card-model-name {
    font-size: 11px;
  }

  .product-price {
    font-size: 15px;
  }

  .product-mrp {
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .product-container {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }

  .product-card {
    padding: 8px;
  }

  .product-image-btn {
    height: 115px;
  }

  .product-image-btn img {
    height: 105px;
  }

  .card-model-name {
    font-size: 10px;
  }

  .card-brand-row > span {
    font-size: 10px;
  }

  .card-category {
    font-size: 10px;
  }

  .product-price {
    font-size: 13px;
  }

  .product-mrp {
    font-size: 11px;
  }
}
`}</style>
      <PurchaseOptionsModal
        isOpen={showPurchaseModal}
        product={pendingPurchaseProduct}
        onClose={() => {
          setShowPurchaseModal(false);
          setPendingPurchaseProduct(null);
        }}
        onConfirm={confirmPurchaseType}
      />
    </>
  );
};

export default ProductSpares;
